import COLORS from '../../../../utils/constants/colors'

const subscriptionFormStyles = {
  container: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  section: {
    border: '1px solid #d3d3d3',
    borderRadius: 4,
    padding: '20px 24px',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  sectionActions: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  summaryText: {
    color: COLORS.darkGrey,
    fontSize: '1rem',
    lineHeight: 1.6,
  },
  formActions: {
    display: 'flex',
    gap: '12px',
    marginTop: '16px',
  },
  cancelButton: {
    textTransform: 'none',
    fontSize: '0.875rem',
    height: 36,
  },
  editButton: {
    textTransform: 'none',
    border: '1px solid #d3d3d3',
    borderRadius: 4,
    padding: '4px 16px',
    fontSize: '0.875rem',
    height: 36,
  },
  textButtons: { color: COLORS.blue },
}

export default subscriptionFormStyles
